import React, { FC, useState } from 'react';

import { IngredientCategoryArrayField } from 'models/entities/ingredient-category';
import { StringArrayField } from 'models/value-objects/editor-field';
import { Model } from './index.model';

import { StringArrayInput } from 'views/components/inputs';

interface Props {
  field: IngredientCategoryArrayField;
  onEdit: (field: IngredientCategoryArrayField) => void;
  focused?: boolean;
}

const CategoryArrayInput: FC<Props> = ({ field, onEdit, focused = false }) => {

  const [model, setModel] = useState(new Model({ field }));

  function edit(stringArrayField: StringArrayField) {
    const it = model.apply(stringArrayField);
    onEdit(it.field);
    setModel(it);
  }

  return (
    <StringArrayInput field={model.stringArrayField} onEdit={stringArrayField => edit(stringArrayField)} focused={focused} />
  );

};

export { CategoryArrayInput };